import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";

// "Edit Staff Details" dialog — display name only, email is read-only.
export default function EditStaffDialog({ open, onOpenChange, selectedStaff, editName, setEditName, onSave }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="edit-staff-modal">
        <DialogHeader>
          <DialogTitle>Edit Staff Details</DialogTitle>
          <DialogDescription>Update this receptionist's display name. Email cannot be changed.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div><Label>Name</Label><Input data-testid="edit-staff-name-input" value={editName} onChange={(e) => setEditName(e.target.value)} /></div>
          <div><Label>Email</Label><Input value={selectedStaff?.email || ""} disabled className="bg-slate-50 text-slate-400" /></div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button data-testid="edit-staff-submit-btn" className="bg-teal-700 hover:bg-teal-800" disabled={!editName.trim()} onClick={onSave}>Save Changes</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
